// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2pwe5","title":"Info_title__28Xqg","selects":"Info_selects__2leDx","requiredAsterisk":"Info_requiredAsterisk__1FLt5"};